import { Injectable } from '@angular/core';

const formatDecimal3 = (params: any): string => {
  if (params.node.group && !params.node.leafGroup) return '';
  if (params.value == null || params.value === '') return '';
  const num = Number(params.value);
  if (isNaN(num)) return String(params.value);
  return num.toFixed(3);
};

@Injectable({
  providedIn: 'root'
})
export class EEAOutputProjectStep1n2ResultSummaryColdef {

  constructor() { }

  public getColumnsDefinition( isProjectOwnershipValid: boolean ): any {
    return [
      {
        headerName: 'SME Selection',
        pinned: true,
        checkboxSelection: isProjectOwnershipValid,
        editable: false,
        width: 117,
        sortable: true,
        field: 'eeaSmeSelection',
        hide: !isProjectOwnershipValid,
        filter: false,
        cellRenderer: 'checkBoxRenderer',
        cellRendererParams: {
          show: false
        }
      },
      {
        headerName: "Run ID",
        field: "runId",
        width: 130,
        filter: false,
        wrapText: false,
        resizable: true,
        sortable: true,
        pinned: true,
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
      },
      {
        headerName: "Application Scheme",
        field: "ApplicationScheme",
        width: 180,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        rowGroup: true,
        hide: true,
        sort: 'asc',
      },
      {
        headerName: "Crop",
        field: "cropName",
        width: 160,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
      },
      {
        headerName: "BBCH",
        field: "bbch",
        width: 100,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
      },
      {
        headerName: "Number of applications",
        field: "applicationNumber",
        width: 150,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
      },
      {
        headerName: "Interval (days)",
        field: "applicationInterval",
        width: 120,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
      },
      {
        headerName: "Application rate (g/ha)",
        field: "applicationRate",
        width: 160,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        valueGetter: (params: any) => params.data ? Number(params.data.applicationRate) : params.value,
        valueFormatter: formatDecimal3,
      },
      {
        headerName: "Crop coverage",
        field: "cropCoverage",
        width: 130,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
      },
      {
        headerName: "Endpoints Data Set",
        field: "Dataset",
        width: 200,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
      },
      {
        headerName: "Compound",
        field: "Compound",
        width: 120,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        pivot: true,
        hide: true,
      },
      {
        headerName: "Scenario FOCUS",
        field: "ScenarioFocus",
        width: 150,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        rowGroup: true,
        hide: true,
        sort: 'asc',
      },
      {
        headerName: "Region",
        field: "Region",
        width: 130,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        pinned: true,
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        rowGroup: true,
        hide: true,
      },
      {
        headerName: "Period",
        field: "Period",
        width: 150,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        pinned: true,
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
      },
      {
        headerName: 'PECsw by compound',
        children: [
          {
            headerName: "Max PECsw \n (µg/L)",
            field: "MaxPecSw",
            width: 140,
            filter: 'agSetColumnFilter',
            wrapText: false,
            resizable: true,
            sortable: true,
            enableRowGroup: true,
            enablePivot: true,
            enableValue: true,
            aggFunc: 'max',
            hide: true,
            valueGetter: (params: any) => params.data ? Number(params.data.MaxPecSw) : params.value,
            valueFormatter: formatDecimal3,
          },
        ]
      },
        {
          headerName: "7 d - PECsw,twa \n (µg/L)",
          field: "SevenDaysPecSwTwa",
          width: 150,
          filter: 'agSetColumnFilter',
          wrapText: false,
          resizable: true,
          sortable: true,
          enableValue: true,
          hide: true,
          valueGetter: (params: any) => params.data ? Number(params.data.SevenDaysPecSwTwa) : params.value,
          valueFormatter: formatDecimal3,
        },
        {
          headerName: "21 d - PECsw,twa \n (µg/L)",
          field: "PecSwTwa21Days",
          width: 150,
          filter: 'agSetColumnFilter',
          wrapText: false,
          resizable: true,
          sortable: true,
          enableValue: true,
          hide: true,
          valueGetter: (params: any) => params.data ? Number(params.data.PecSwTwa21Days) : params.value,
          valueFormatter: formatDecimal3,
        },

      {
        headerName: `Max PECsed \n (µg/kg)`,
        field: "MaxPecSed",
        width: 140,
        filter: 'agSetColumnFilter',
        wrapText: false,
        resizable: true,
        sortable: true,
        enableValue: true,
        valueGetter: (params: any) => params.data ? Number(params.data.MaxPecSed) : params.value,
        valueFormatter: formatDecimal3,
      }
    ];
  }
}
